// composables/useFacebook.ts
export function useFacebookLogin(appId: string) {
  onMounted(() => {
    if (process.client && !window.FB) {
      const script = document.createElement("script");
      script.src = "https://connect.facebook.net/en_US/sdk.js";
      script.async = true;
      script.defer = true;
      script.onload = () => {
        window.FB.init({
          appId,
          cookie: true,
          xfbml: false,
          version: 'v18.0',
          status: true, 
        });
      };
      document.head.appendChild(script);
    }
  });

  function facebookLogin() {
    return new Promise((resolve, reject) => {
      if (!window.FB) {
        reject("Facebook SDK 未加载");
        return;
      }
      window.FB.login((response) => {
        if (response.authResponse) {
          resolve(response.authResponse);
        } else {
          reject("用户取消授权");
        }
      }, { scope: 'public_profile,email' });
    });
  }

  return { facebookLogin };
}